<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="table"
      :custom-on-row-click="showDetailOf"
      entity-name="print_bill_list"
      :model="model"
      :use-default-action="false"
      :use-select="false"
      :uuse-custom-action="true"
      icon="mdi-clipboard-list"
    >
      <template #[`item.content`]="{item}">
        <v-btn
          class="mr-0"
          color="amber lighten-5 black--text"
          elevation="0"
          small
          @click.stop="reprint(item)"
        >
          <v-icon
            left
          >
            mdi-printer
          </v-icon>
          {{ $t('reprint') }}
        </v-btn>
      </template>
    </ik-data-table>
    <v-dialog
      v-model="showDetail"
      width="480px"
    >
      <v-card
        class="pa-4"
        width="100%"
      >
        <i-k-p-r-node
          :node="parseNode(currentPrintContent)"
          level=""
          style="font-family: monospace"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import PrinterList from '@/model/dataLayer/api/print/PrinterList'
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import { parse } from 'node-html-parser'
import IKPRNode from '@/views/widget/commonLogic/IKPRNode.vue'
import { showSuccessMessage } from '@/model/utils/utils'

export default {
  components: {
    IKPRNode,
    IkDataTable
  },
  data: function () {
    return ({
      model: PrinterList,
      showDetail: false,
      currentPrintContent: ''

    })
  },
  methods: {
    parseNode (node) {
      return parse(node)
    },
    async reprint (item) {
      await this.model.reprint(item)
      setTimeout(() => {
        this.$refs.table.reload()
      }, 1000)

      showSuccessMessage()
    },
    showDetailOf (item) {
      console.log(item)
      this.showDetail = true
      this.currentPrintContent = item.content
    }
  }
}
</script>
